import ComponentInventory from "@/components/ComponentInventory";
import FinishedGoodsInventory from "@/components/FinishedGoodsInventory";

export default function Inventory({ kind = "components" }) {
  const isComponents = kind === "components";
  return (
    <main className="mx-auto max-w-[1400px] px-6 py-10 md:px-10 md:py-12" data-testid="inventory-page">
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">Stock</p>
      <h1 className="mt-2 font-heading text-4xl font-black tracking-tighter text-slate-900 sm:text-5xl">
        {isComponents ? "Component Inventory" : "Finished Goods"}
      </h1>
      <p className="mt-2 text-sm text-slate-500">
        {isComponents
          ? "Track on-hand stock levels for your raw material components."
          : "Track on-hand stock levels for your finished products."}
      </p>
      <div className="mt-8" data-testid={`inventory-panel-${isComponents ? "components" : "finished"}`}>
        {isComponents ? <ComponentInventory /> : <FinishedGoodsInventory />}
      </div>
    </main>
  );
}
